import { IDateRange } from "components/dashboard/product-template-table/utils/interfaces";
import { DatasetLoadingConf } from "../interfaces";

export enum XAxisType {
  TIME = "Time",
  VALUES = "Values",
}

export enum BoundType {
  MIN_MAX = "Min-Max",
  STD_DEV = "Standard Deviation",
  CONFIDENCE = "Confidence Interval",
}

export interface ConfidenceIntervalLineChartProps extends IDateRange {
  identifiers: string[];
  timeBoundIntervalInSeconds?: number;
  valueBoundsCount?: number;
  loadConf: DatasetLoadingConf;
  boundType: BoundType;
  xAxisType: XAxisType;
  hideHeader?: boolean;
  updateFrequency?: number;
  showDateSelection?: boolean;
  hideRefresh?: boolean;
}
